export enum ApprovalStatusType {
  Saved = 'SAVED', //the user saved the transaction
  ActionRequired = 'ACTION_REQUIRED', //the user saved the transaction
  Submitted = 'SUBMITTED', //the user submitted the transaction

  Approved = 'APPROVED', //approver approved the transaction
  Rejected = 'REJECTED', //approver rejected the transaction
  Cancelled = 'CANCELLED', //approver cancelled the transaction and only the approver can cancel the transaction

  Assigned = 'ASSIGNED',
  Unassigned = 'UNASSIGNED',

  Pending = 'PENDING', //approvalRunTime set the transaction's current status to PENDING
  Error = 'ERROR', //approvalRunTime found validation error and set the transaction's current status to ERROR
  Completed = 'COMPLETED', //approvalRunTime set the transaction's current status to COMPLETED after the approver approved the transaction

  NotAvailable = 'NOT_AVAILABLE', // Front end purpose Only

  InProgress = 'INPROGRESS',
  Start = 'START',


  // recruit to hire status
  NoCandidateSelected = 'NO_CANDIDATE_SELECTED',
  WaitingForEmploymentApp = 'WAITING_FOR_EMPLOYMENT_APP',
  WaitingForNewHireRequest = "WAITING_FOR_NEW_HIRE_REQUEST",
  WaitingForNewHireApproval = "WAITING_FOR_NEW_HIRE_APPROVAL",
  WaitingForSignedOfferLetter = "WAITING_FOR_SIGNED_OFFER_LETTER",
  WaitingForOnboardingAcks = "WAITING_FOR_ONBOARDING_ACKS",
  WaitingForVirtualOrientation = "WAITING_FOR_VIRTUAL_ORIENTATION",
  OnboardingComplete = "ONBOARDING_COMPLETE",
  NewHireRejected = "NEW_HIRE_REJECTED",
}